import { SearchQuery } from 'modules/domains';
import { replaceElementAt } from 'utils/arrayHelpers';

import { useRootQueryState } from '../useRootQueryState';
import { ElementType, useElementIndex } from '../../contexts';
import { useCriteriaArray } from './useCriteriaArray';

export type SetCriteriaFn = (criteria: SearchQuery) => void;

export const useSetCriteria = (): SetCriteriaFn => {
  const [rootQuery, setRootQuery] = useRootQueryState();
  const existingCriteriaArray = useCriteriaArray();
  const indexToUpdate = useElementIndex(ElementType.Criteria);
  return function setCriteria(updatedCriteria: SearchQuery) {
    setRootQuery({
      ...rootQuery,
      searchQueries: replaceElementAt(existingCriteriaArray, indexToUpdate, updatedCriteria),
    });
  };
};
